import { atom } from "recoil";

export const updateUserDrawerState = atom({
  key: "updateUserDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
